// extracted by mini-css-extract-plugin
export default {"bg":"link_bg__RZ8Vx","headLink":"link_headLink__Lp3iK","button":"link_button__AhK2X"};